<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>设备编号：</label>
                        <el-input v-model="search_Obj.f_device_code" clearable style="width: 150px" @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>通道编号：</label>
                        <el-input v-model="search_Obj.f_channel_no" clearable style="width: 150px" @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>报警类型：</label>
                        <el-select v-model="search_Obj.f_alert_type" clearable placeholder="请选择" style="width: 200px" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('alert_type')" :key="'alert_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup">
                        <label>告警用户：</label>
                        <el-input v-model="search_Obj.f_user_name" clearable style="width: 150px" @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>告警时间：</label>
                        <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="dateRangeSet"
                            style="width:420px">
                        </el-date-picker>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column prop="device_code" label="设备编号" sortable="custom"></el-table-column>
                        <el-table-column prop="channel_no" label="通道编号" sortable="custom"></el-table-column>
                        <el-table-column prop="alert_type" label="警告类型" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.alert_type, "alert_type") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="value" label="警告值" sortable="custom"></el-table-column>
                        <el-table-column prop="user_name" label="告警用户" sortable="custom"></el-table-column>
                        <el-table-column prop="datetime" label="警告时间" sortable="custom"></el-table-column>
                        <el-table-column label="操作" width="120" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Info
                    width="600px"
                    :id="model_id"
                    title="查看警告消息"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
            </div>
        </el-card>
    </div>
</template>

<script>
import LabBtns from "@/components/common/labbtns"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'alertMsgList',
    mixins: [listutil],
    components: { Info, LabBtns},
    data() {
        return {
            m_name: '警告消息',
            menu_id: 2100,
            list_url: "/api/admin/alertmsg/list",
            search_Obj: {
                f_device_code: '',
                f_channel_no: '',
                f_alert_type: '',
                f_user_name: '',
                f_datetime_s_date: '',
                f_datetime_e_date: ''
            },
            del_Obj:{
                url:'/api/admin/alertmsg/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['alert_type'],
            dateRange: [],
        };
    },
    methods: {
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_datetime_s_date = val[0]
                this.search_Obj.f_datetime_e_date = val[1]
            }else{
                this.search_Obj.f_datetime_s_date = ''
                this.search_Obj.f_datetime_e_date = ''
            }
        },
    }
};
</script>